// extracted by mini-css-extract-plugin
export default {"DismissibleFlashContainer":"DismissibleFlash-module__DismissibleFlashContainer--JmjfS","dismissButton":"DismissibleFlash-module__dismissButton--yNEaw"};